import { PatientGroupQuery, PatientGroupRemoveCommand } from '@dreryk/egabinet-patient-frontend-api';

import { refetchCqrsQuery, useCqrsCommand } from '@dreryk/command-query-react-common';
import { dispatchSnackbarPositiveEvent } from '@dreryk/react-components';
import { PromiseVoidFunction } from '@dreryk/react-common';

import { translationKeys } from '../../../translations';

type CustomPatientGroupsRemoveActionRenderProps = {
   removeCustomPatientGroup: PromiseVoidFunction;
};

type CustomPatientGroupsRemoveActionProps = {
   children: (renderProps: CustomPatientGroupsRemoveActionRenderProps) => JSX.Element;
   patientGroupId: number;
};

export const CustomPatientGroupsRemoveAction = (props: CustomPatientGroupsRemoveActionProps): JSX.Element => {
   const { executeAsync } = useCqrsCommand<void, void>(
      () => {
         const command = new PatientGroupRemoveCommand();
         command.id = props.patientGroupId;
         return command;
      },
      {
         onSuccess: () => {
            dispatchSnackbarPositiveEvent(translationKeys.customGroupHasBeenRemoved);
            refetchCqrsQuery(PatientGroupQuery);
         },
      }
   );

   return props.children({ removeCustomPatientGroup: executeAsync });
};
